module.exports = __webpack_public_path__ + "static/media/stock-scrap.f4b5f5c7.svg";